import { Col, Form, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import Select, { SelectOption } from '@amzn/meridian/select';

import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Text from '@amzn/meridian/text';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';

/*
 * Select attribute, where the name is constant and values are predefined.
 */
const SelectAttribute = ({ id, name, allowedValues, onChange, onRemoveAttribute, disabled = false, initialValue }) => {
  const [attributeValue, setAttributeValue] = useState([]);

  useEffect(() => {
    setAttributeValue(initialValue);
  }, [initialValue]);

  const updateAttributeValue = newValue => {
    setAttributeValue(newValue);
    onChange(id, name, newValue);
  };

  const removeThisElement = () => {
    onRemoveAttribute(id);
  };

  return (
    <Row className="m-1">
      <Col className="col-10">
        <Row>
          <Form.Group as={Col} className="col-6">
            <Text type="b200" tag="label" color="primary" htmlFor={`name-input-${id}`}>
              Attribute name
            </Text>
            <Form.Control id={`name-input-${id}`} type="text" disabled placeholder={name} />
          </Form.Group>
          <Form.Group as={Col} className="col-6">
            <Text type="b200" tag="label" color="primary" htmlFor={`value-select-${id}`}>
              Attribute value
            </Text>
            <Select
              id={`value-select-${id}`}
              width="100%"
              placeholder="Select value(s)"
              value={attributeValue}
              onChange={updateAttributeValue}
              disabled={disabled}
            >
              {allowedValues.sort().map(allowedValue => {
                return <SelectOption value={allowedValue} key={allowedValue} label={allowedValue} />;
              })}
            </Select>
          </Form.Group>
        </Row>
      </Col>
      <Col className="col-2 d-flex justify-content-center">
        <Button
          type="tertiary"
          className="mb-3 align-self-end mr-1"
          onClick={() => removeThisElement()}
          disabled={disabled}
        >
          <Icon tokens={trashTokens}></Icon>
        </Button>
      </Col>
    </Row>
  );
};

export default SelectAttribute;
